<template>
  <div
    class="h-screen w-24 bg-white border border-[#385660] flex flex-col justify-start items-center transition-all duration-500 z-40"
    :class="{
      'left-[-100%]': (isMobile && !props.isMobileMenuOpen),
      'left-0': props.isMobileMenuOpen,
      'hidden lg:flex': !isMobile && !props.isMobileMenuOpen,
      'fixed top-0 left-0': isMobile || props.isMobileMenuOpen,
      'lg:sticky lg:top-0': !isMobile
    }">
    <img src="@/assets/img/ads_logo_2.png" alt="" class="p-4 mb-4 mt-4" />

    <div class="flex flex-col justify-evenly items-center h-[70vh]">
      <NavItemAnimate to="/" :icon-animated="homelottie" :title="$t('menu.home')" />
      <NavItemAnimate to="/supplys" :icon-animated="articlelottie" :title="$t('menu.clients')" />
      <NavItemAnimate to="/request" :icon-animated="assignmentlottie" :title="$t('menu.requests')" />
      <NavItemAnimate to="/user" :icon-animated="userlottie" :title="$t('menu.users')" />
      <NavItem v-if="isAdsUser()" to="/liquidation" :icon="liquidation" :title="$t('menu.liquidation')"
        class="transition-all duration-700 ease-in-out" />
      <NavItem v-if="canViewOperationalReport" to="/report" :icon="report" :title="$t('menu.report')" class="" />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import NavItemAnimate from '../button/NavItemAnimate.vue';
import NavItem from '@/components/button/NavItem.vue';
import liquidation from '@/assets/svg/liquidation.vue';
import report from '@/assets/svg/report.vue';
import userlottie from '@/assets/animate/user.json';
import articlelottie from '@/assets/animate/article.json';
import homelottie from '@/assets/animate/home.json';
import assignmentlottie from '@/assets/animate/assignment.json';
import { canAccessOperationalReport } from '@/services/operationalReportAccess';
import { isAdsUser } from '@/services/userRoles';

const props = defineProps({
  isMobileMenuOpen: {
    type: Boolean,
    default: false
  }
})

const isMobile = ref(false)
const canViewOperationalReport = ref(false)

const checkMobile = () => {
  isMobile.value = window.innerWidth < 1024
}

onMounted(async () => {
  checkMobile()
  window.addEventListener('resize', checkMobile)

  try {
    canViewOperationalReport.value = await canAccessOperationalReport()
  } catch (error) {
    console.error('No se pudo comprobar el acceso al informe operativo', error)
    canViewOperationalReport.value = false
  }
})

onUnmounted(() => {
  window.removeEventListener('resize', checkMobile)
})
</script>

<style scoped>
.bg-gradient {
  background-image: linear-gradient(to bottom, #385660, #49707E, #3A5762);
}

/* Transición suave para el menú móvil */
.menu-expanded {
  transition: all 0.5s ease;
}
/*
@media (max-width: 768px) {

  .w-24,
  .w-64 {
    width: 100%;
    max-width: 280px;
    transition: left 0.3s ease;
  }
} */
</style>
